import { useState } from "react";
import { X, Trash2, Percent, Tag, Receipt } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { NumPad } from "@/components/NumPad";

const Btn = ({ onClick, children, cls, testid }) => (
  <button type="button" onClick={onClick} className={`h-12 rounded-xl font-bold flex items-center justify-center gap-1.5 text-sm ${cls}`} data-testid={testid}>{children}</button>
);

export default function TpvKeypad({ cart, sel, setQty, onLineDisc, onPrice, onTicketDisc }) {
  const { t } = useApp();
  const [v, setV] = useState("");
  const line = cart.find((l) => l.product_id === sel) || cart[cart.length - 1];
  const n = Number(v);
  const run = (fn) => { if (line && v !== "") fn(line, n); setV(""); };
  return (
    <div className="tpv-keypad rounded-2xl bg-white border border-border p-3 space-y-2" data-testid="tpv-keypad">
      <div className="flex items-center justify-between gap-2 rounded border border-[#CCCCCC] bg-[#F0F0F0] text-[#222222] px-3 h-12">
        <span className="text-xs truncate opacity-80" data-testid="tpv-keypad-line">{t("selected_line")}: {line?.name}</span>
        <span dir="ltr" className="font-mono-receipt text-xl font-bold text-[#5EE3A1]" data-testid="tpv-keypad-value">{v || "0"}</span>
      </div>
      <NumPad value={v} onChange={setV} testid="tpv-numpad" compact />
      <div className="grid grid-cols-3 gap-2">
        <Btn onClick={() => run((l, x) => x > 0 && setQty(l.product_id, x))} cls="bg-[#0B2A5B] text-white" testid="tpv-keypad-qty-btn"><X className="w-4 h-4" />{t("qty_key")}</Btn>
        <Btn onClick={() => run((l, x) => x >= 0 && x <= 100 && onLineDisc(l, x))} cls="bg-[#E67E22]/15 text-[#A85A12]" testid="tpv-keypad-line-disc-btn"><Percent className="w-4 h-4" />{t("line_disc")}</Btn>
        <Btn onClick={() => run((l, x) => x > 0 && onPrice(l, x))} cls="bg-[#3498DB]/15 text-[#1F6FA8]" testid="tpv-keypad-price-btn"><Tag className="w-4 h-4" />{t("set_price")}</Btn>
        <Btn onClick={() => { if (v !== "" && n >= 0 && n <= 100) onTicketDisc(n); setV(""); }} cls="bg-[#1F9D55]/15 text-[#1F9D55] col-span-2" testid="tpv-keypad-ticket-disc-btn"><Receipt className="w-4 h-4" />{t("ticket_disc")}</Btn>
        <Btn onClick={() => line && setQty(line.product_id, 0)} cls="bg-destructive/10 text-destructive" testid="tpv-keypad-remove-btn"><Trash2 className="w-4 h-4" />{t("sc_delete_line")}</Btn>
      </div>
    </div>
  );
}
